import {
  BookingStatus,
  DriverAllocationStatus,
  ManualDriverInvoiceBatchItemDto,
  ManualDriverInvoiceCandidateDto,
} from 'generated/graphql'

import { getBookingReference } from './bookingDetails.helpers'
import { numberFormat } from './numberFormat'

// Job cost with the currency agreed with the driver, e.g. "120.00 EUR"
export const formatJobCost = (cost: number, currencyCode?: string | null) =>
  `${numberFormat(cost)} ${currencyCode ?? ''}`.trim()

// Booking statuses a booking can have when it is eligible for manual invoice generation
export const getManualInvoiceBookingStatusLabel = (status: BookingStatus) => {
  const labels: Partial<Record<BookingStatus, string>> = {
    [BookingStatus.ProofOfDelivery]: 'Delivered',
    [BookingStatus.Complete]: 'Complete',
    [BookingStatus.Invoice]: 'Invoice',
  }

  return labels[status] ?? status
}

export const getAllocationStatusLabel = (status: DriverAllocationStatus) => {
  const labels: Record<DriverAllocationStatus, string> = {
    [DriverAllocationStatus.Awaiting]: 'Not accepted',
    [DriverAllocationStatus.Accepted]: 'Accepted',
    [DriverAllocationStatus.Declined]: 'Declined',
  }

  return labels[status]
}

// Title of a selected booking in the confirmation list
export const getCandidateTitle = (candidate: ManualDriverInvoiceCandidateDto) =>
  `${getBookingReference(candidate.bookingId)} – ${candidate.driverName}`

// Job cost, tariff and whether only the APR will be generated, for the confirmation list
export const getCandidateSummary = (candidate: ManualDriverInvoiceCandidateDto) =>
  [
    formatJobCost(candidate.cost, candidate.currencyCode),
    candidate.tariffName,
    candidate.invoiceId ? `APR only: invoice ${candidate.invoiceId} already exists` : null,
  ]
    .filter(Boolean)
    .join(' · ')

export const getQueuedMessage = (item: ManualDriverInvoiceBatchItemDto) =>
  item.isAprOnly
    ? 'Queued for APR generation (the invoice already exists).'
    : 'Queued for invoice and APR generation.'
